import { createAction } from '@ngrx/store';

import { userDetails } from '../../models/delete.model';
import { DeleteMyAccountResponse } from './delete-myaccount.model';

export const RESET = '[Delete Myaccount] Reset';
const UNENROLL_PROGRAMS = '[Delete Myaccount] Unenroll Programs';
export const UNENROLL_USER_FAIL = '[Delete Myaccount] Unenroll Programs Fail';
export const UNENROLL_USER_SUCCESS = '[Delete Myaccount] Unenroll Programs Success';
const DELETE_MYACCOUNT_ACTION = '[Delete Myaccount] Delete';
export const DELETE_MYACCOUNT_ACTION_SUCCESS = '[Delete Myaccount] Delete Success';
export const DELETE_MYACCOUNT_ACTION_FAIL = '[Delete Myaccount] Delete Fail';
const SEND_TEMPLATED_EMAIL_ACTION = '[Delete Myaccount] Send Templated Emails';
export const SEND_TEMPLATED_EMAIL_ACTION_SUCCESS =
  '[Delete Myaccount] Send Templated Emails Success';
export const SEND_TEMPLATED_EMAIL_ACTION_FAIL = '[Delete Myaccount] Send Templated Emails Fail';

export const ResetAction = createAction(RESET);

export const UnenrollProgramsAction = createAction(UNENROLL_PROGRAMS);

export const UnenrollUserActionFail = createAction(
  UNENROLL_USER_FAIL,
  (payload: DeleteMyAccountResponse) => ({
    payload
  })
);

export const UnenrollUserActionSuccess = createAction(
  UNENROLL_USER_SUCCESS,
  (payload: DeleteMyAccountResponse) => ({
    payload
  })
);

export const DeleteMyAccountAction = createAction(DELETE_MYACCOUNT_ACTION);

export const DeleteMyAccountActionSuccess = createAction(
  DELETE_MYACCOUNT_ACTION_SUCCESS,
  (payload: DeleteMyAccountResponse) => ({ payload })
);

export const DeleteMyAccountActionFail = createAction(
  DELETE_MYACCOUNT_ACTION_FAIL,
  (payload: DeleteMyAccountResponse) => ({ payload })
);

export const SendTemplatedEmailsAction = createAction(
  SEND_TEMPLATED_EMAIL_ACTION,
  (payload: userDetails) => ({
    payload
  })
);

export const SendTemplatedEmailsActionSuccess = createAction(
  SEND_TEMPLATED_EMAIL_ACTION_SUCCESS,
  (payload: DeleteMyAccountResponse) => ({ payload })
);

export const SendTemplatedEmailsActionFail = createAction(
  SEND_TEMPLATED_EMAIL_ACTION_FAIL,
  (payload: DeleteMyAccountResponse) => ({ payload })
);

export type Actions =
  | ReturnType<typeof ResetAction>
  | ReturnType<typeof UnenrollProgramsAction>
  | ReturnType<typeof UnenrollUserActionFail>
  | ReturnType<typeof UnenrollUserActionSuccess>
  | ReturnType<typeof DeleteMyAccountAction>
  | ReturnType<typeof DeleteMyAccountActionSuccess>
  | ReturnType<typeof DeleteMyAccountActionFail>
  | ReturnType<typeof SendTemplatedEmailsAction>
  | ReturnType<typeof SendTemplatedEmailsActionSuccess>
  | ReturnType<typeof SendTemplatedEmailsActionFail>;
